// extracted by mini-css-extract-plugin
export default {"ErrorHandler":"ErrorHandler__ErrorHandler--KjYcB","ErrorHandler__error":"ErrorHandler__ErrorHandler__error--a8Owf"};